import React, { HTMLAttributes } from "react";

import classnames from "classnames";

import { StyledDialogActions } from "./Styles";
// import { useDialogContext } from "./DialogContext";

export const DialogActions = ({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) => {
  // useDialogContext();

  return (
    <StyledDialogActions
      className={classnames("c-dialog-actions", className)}
      {...rest}
    >
      {children}
    </StyledDialogActions>
  );
};

DialogActions.displayName = "DialogActions";
